import { Contact } from '../models/address';
import { JsonPatchOperation } from '../models/json-patch-operation';

type EditableContactField = Exclude<keyof Contact, 'isCurrent'>;

const EDITABLE_CONTACT_FIELDS: EditableContactField[] = [
  'street',
  'number',
  'floor',
  'apartment',
  'city',
  'postcode',
  'state',
  'country',
  'homePhoneNumber',
  'mobilePhoneNumber',
  'email',
];

const toNullable = (value: string): string | null => (value === '' ? null : value);

export const buildContactPatchOperations = (
  memberId: string,
  original: Contact,
  updated: Contact
): JsonPatchOperation[] => {
  const hasChanges = EDITABLE_CONTACT_FIELDS.some(
    (field) => original[field] !== updated[field]
  );

  if (!hasChanges) {
    return [];
  }

  return [
    {
      op: 'add',
      path: '/contacts/-',
      value: {
        ownerId: memberId,
        street: updated.street,
        number: updated.number,
        floor: toNullable(updated.floor),
        apartment: toNullable(updated.apartment),
        city: updated.city,
        postcode: updated.postcode,
        state: updated.state,
        country: updated.country,
        isCurrent: true,
        homePhoneNumber: toNullable(updated.homePhoneNumber),
        mobilePhoneNumber: toNullable(updated.mobilePhoneNumber),
        email: toNullable(updated.email),
      },
    },
  ];
};

export const buildLinkMemberPatchOperation = (userId: string): JsonPatchOperation[] => [
  {
    op: 'replace',
    path: '/UserId',
    value: userId,
  },
];
